import { resetLocalization } from 'utils/localization';

const ResetSection = () => {
    resetLocalization();
    window.location.href = '/';
    return null;
};

export default ResetSection;
